import api from '.';

class Code {
  static async getCodes() {
    const codes = await api.get('/code');
    return codes.data;
  }
}

export default Code;
